var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pen-a",
    d: "M62.8724673,9.12867597 C67.8981358,14.154808 66.0899973,17.5760943 62.8724673,20.79925 L58.9835515,24.6885246 L47.3114754,13.0179505 L51.2003913,9.12867597 C54.4230778,5.90827069 57.8467989,4.10254395 62.8724673,9.12867597 Z M9.81883843,50.714664 L6,66 L21.2861638,62.178666 L55.1803279,28.2863765 L43.7104689,16.8196721 L9.81883843,50.714664 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pen-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pen.35f400e6760aec9185990a7af06d731e.svg";